import { render, staticRenderFns } from "./BarDetail.vue?vue&type=template&id=6bc8b1d1"
import script from "./BarDetail.vue?vue&type=script&lang=js"
export * from "./BarDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports